//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
let d=[[[0,"SolveOption",0,0],[0,"UpdateMethod",0,0]],[[["solveOption"],"SetSolveOption",{},1,0],[[],"Reconfigure",{},0,0],[["updateMethod"],"SetUpdateMethod",{},1,0],[[],"OnApplyPre",{},0,0]],[]];
SPLM.Features.AdmBaseBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.AdmBaseBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.AdmBaseBuilder.SolveOptionType = Object.freeze({
    "C1" : "C1", "C2" : "C2"});

SPLM.Features.AdmBaseBuilder.UpdateMethodType = Object.freeze({
    "FaceChange" : "FaceChange", "AutomaticRecovery" : "AutomaticRecovery", "Automatic" : "Automatic", "Multiple" : "Multiple"});

export default SPLM;